// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2aQCh","inner":"Footer_inner__1wlZS"};